import { render, staticRenderFns } from "./ProductionSheetItems.vue?vue&type=template&id=4097ca62&scoped=true"
import script from "./ProductionSheetItems.vue?vue&type=script&lang=js"
export * from "./ProductionSheetItems.vue?vue&type=script&lang=js"
import style0 from "./ProductionSheetItems.vue?vue&type=style&index=0&id=4097ca62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4097ca62",
  null
  
)

export default component.exports